<div class="login-top-bar">
  <div class="login-logo">
    <img src="../../assets/img/Logo_bianco.png" alt="Logo" />
  </div>
  <div class="background-logo">
    <img src="../../assets/img/sfondo_frecce.png" alt="Background-logo" class="side-logo mt-4" />
  </div>
</div>
<div class="login-container">
  <h2 class="login-title">
    {{ 'PERSONAL_INFO_FORM.PASSWORD_CHANGE_TITLE' | translate }}
  </h2>
  <form [formGroup]="form" class="form-container">
    <div class="row mt-5">
      <div class="col-12">
        <div>
          <div class="input-wrapper">
            <p class="password-label">
              {{ 'PERSONAL_INFO_FORM.PASSWORD_CHANGE_LABEL' | translate }}
            </p>
          </div>
          <div class="input-wrapper">
            <app-icam-input
              label="{{ 'CURRENT_PASSWORD' | translate }}"
              inputId="currentPassword"
              formControlName="currentPassword"
              [isSlim]="true"
              inputType="password"
              [ngClass]="isLight ? 'light' : 'dark'"
              >
            </app-icam-input>
          </div>
          <div formGroupName="passwords">
            <div class="input-wrapper">
              <app-icam-input
                label="{{ 'Nuova password' | translate }}"
                inputId="newPassword"
                formControlName="password"
                [isSlim]="true"
                inputType="password"
                [ngClass]="isLight ? 'light' : 'dark'"
                />
            </div>
            <div class="input-wrapper">
              <app-icam-input
                label="{{ 'CONFIRM_NEW_PASSWORD' | translate }}"
                inputId="confirmPassword"
                formControlName="confirmPassword"
                [isSlim]="true"
                inputType="password"
                [ngClass]="isLight ? 'light' : 'dark'"
                />
            </div>
          </div>
          @if (passwordFormField && passwordFormField.value) {
            <app-password-validators [value]="passwordFormField.value" />
          }
          @if (passwordsGroup.errors?.['PasswordNoMatch']) {
            <div class="text-accent-red text-start">
              {{ 'NEW_PASSWORD.NO_MATCH' | translate }}
            </div>
          }
          @if (isErrorChangePassword) {
            <div
            [ngClass]="{
                    'text-accent-red': isErrorChangePassword,
                  }"
              class="text-start"
              >
              {{ 'PASSWORD_CHANGE_ERROR' | translate }}
            </div>
          }
          @if (!isNewPassword) {
            <div
            [ngClass]="{
              'text-accent-red': !isNewPassword,
            }"
              class="text-start"
              >
              {{ 'PASSWORD_SAME_ERROR' | translate }}
            </div>
          }
          @if (isSuccessChangePassword) {
            <div
            [ngClass]="{
              'text-success': isSuccessChangePassword
            }"
              class="text-start"
              >
              {{ 'PASSWORD_CHANGED_SUCCESS' | translate }}
            </div>
          }
          <button
            id="button-change-password-save"
            (click)="onSaveNewPassword()"
            class="button-form-submit"
            [class.disabled]="!passwordsGroup.valid || !form.value.currentPassword || isLoading"
            [disabled]="!passwordsGroup.valid || !form.value.currentPassword || isLoading"
            >
            @if (isLoading) {
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status"></div>
              </div>
            } @else {
              {{ 'PERSONAL_INFO_FORM.SAVE' | translate }}
            }
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
